import { jsx as _jsx } from "react/jsx-runtime";
import { useOwnerBranding } from '../branding.js';
/**
 * Tenant brand mark — placed in the top-right of every template so the
 * rendered PDF identifies the tenant alongside the operating owner.
 * Reads `tenantLogoUrl` / `tenantName` from `OwnerBrandingProvider`.
 * Renders nothing when no logo URL is set (we don't fall back to text
 * on the right slot — a missing tenant brand should be invisible, not
 * substitute as a wordmark that competes with the owner identity).
 */
export function TenantLogo(props) {
    const branding = useOwnerBranding();
    if (!branding?.tenantLogoUrl)
        return null;
    const maxHeight = props.maxHeight ?? '1.2cm';
    const maxWidth = props.maxWidth ?? '5cm';
    return (_jsx("img", { src: branding.tenantLogoUrl, alt: branding.tenantName ?? '', className: "object-contain", style: { maxHeight, maxWidth } }));
}
//# sourceMappingURL=TenantLogo.js.map